// extracted by mini-css-extract-plugin
export default {"mainContainer":"Ccp_mainContainer__p9Clm","wrapperContainer":"Ccp_wrapperContainer__1JHWf"};